import React, { Fragment, useState } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { getImage } from "gatsby-plugin-image"
import { Dialog, Disclosure, Transition } from '@headlessui/react'
import { MenuIcon, XIcon, ChevronDownIcon } from '@heroicons/react/outline'

import UpdateLogoVersion from '../common/UpdateLogoVersion'
import ContactImageVersion from '../common/ContactImageVersion'

const products = [
  { name: 'Command Packages', link: '/command-packages', desc: 'All-In-One Kits by Command Access' },
  { name: 'Low Energy Operator', link: '/low-energy-operator', desc: 'Low Energy Operator by Command Access' },
  { name: 'Mortise Locks', link: '/mortise-locks', desc: 'Electrified Mortise Locks' },
  { name: 'Cylindrical Locks', link: '/cylindrical-locks', desc: 'Electrified Cylindrical Locks' },
  { name: 'Exit Device Kits', link: '/exit-device-kits', desc: 'Motorized & Solenoid Latch Pullback Kits' },
  { name: 'Exit Devices', link: '/exit-devices', desc: 'Motorized & Electrified Exit Devices' },
  { name: 'Exit Trims', link: '/exit-trims', desc: 'Electrified Exit Trims' },
  { name: 'Power Supplies', link: '/power-supplies', desc: 'Power Supplies, Power Sources & Relay Boards' },
  { name: 'Power Transfers', link: '/power-transfers', desc: 'Energy Transfer Hinges & Door Loops' },
  { name: 'Accessories', link: '/accessories', desc: 'Accessories for Electrified Hardware' },
]

const MobileDrawerNew = () => {
  const [open, setOpen] = useState(false)

  const data = useStaticQuery(graphql`
    query MobileDrawerNewQuery {
      prismicNavigation {
        data {
          header_logo {
            gatsbyImageData(
              width: 300
            )
          }
          phone_number
          show_home_menu
          about_menu_name
          contact_menu_name
          contact_image {
            gatsbyImageData(
              width: 300
            )
          }
          contact_image_phone_number
          first_product_category_name
          first_product_category_description
          second_product_category_name
          second_product_category_description
          third_product_category_name
          third_product_category_description
          fourth_product_category_name
          fourth_product_category_description
          fifth_product_category_name
          fifth_product_category_description
          sixth_product_category_name
          sixth_product_category_description
          seventh_product_category_name
          seventh_product_category_description
          eight_product_category_name
          eight_product_category_description
          ninth_product_category_name
          ninth_product_category_description
          tenth_product_category_name
          tenth_product_category_description
          first_resource_name
          first_resource_description
          second_resource_name
          second_resource_description
          third_resource_name
          third_resource_description
          fourth_resource_name
          fourth_resource_description
          fifth_resource_name
          fifth_resource_description
        }
      }
    }
  `)

  const nav = data.prismicNavigation.data
  const logo = getImage(nav.header_logo)
  const contactImg = getImage(nav.contact_image)

  const products = [
    { name: nav.first_product_category_name, link: '/command-packages', desc: nav.first_product_category_description },
    { name: nav.second_product_category_name, link: '/low-energy-operator', desc: nav.second_product_category_description },
    { name: nav.third_product_category_name, link: '/mortise-locks', desc: nav.third_product_category_description },
    { name: nav.fourth_product_category_name, link: '/cylindrical-locks', desc: nav.fourth_product_category_description },
    { name: nav.fifth_product_category_name, link: '/exit-device-kits', desc: nav.fifth_product_category_description },
    { name: nav.sixth_product_category_name, link: '/exit-devices', desc: nav.sixth_product_category_description },
    { name: nav.seventh_product_category_name, link: '/exit-trims', desc: nav.seventh_product_category_description },
    { name: nav.eight_product_category_name, link: '/power-supplies', desc: nav.eight_product_category_description },
    { name: nav.ninth_product_category_name, link: '/power-transfers', desc: nav.ninth_product_category_description },
    { name: nav.tenth_product_category_name, link: '/accessories', desc: nav.tenth_product_category_description },
  ]

  const resources = [
    { name: nav.first_resource_name, link: '/forms', desc: nav.first_resource_description },
    { name: nav.second_resource_name, link: '/distributors', desc: nav.second_resource_description },
    { name: nav.third_resource_name, link: '/knowledgebase', desc: nav.third_resource_description },
    { name: nav.fourth_resource_name, link: '/sales-representatives', desc: nav.fourth_resource_description },
    { name: nav.fifth_resource_name, link: '/blog', desc: nav.fifth_resource_description },
  ]

  return (
    <>
      <div className="xl:hidden flex justify-end">
        <button
          className="text-site-gray focus:outline-none focus:ring-2 focus:ring-white bg-transparent hover:bg-transparent p-0 ml-4"
          onClick={() => setOpen(true)}
        >
          <span className="sr-only">Open panel</span>
          <MenuIcon className="h-6 w-6 text-white" aria-hidden="true" />
        </button>
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" static className="fixed inset-0 overflow-hidden z-50" open={open} onClose={setOpen}>
          <div className="absolute inset-0 overflow-hidden">
            <Transition.Child
              as={Fragment}
              enter="ease-in-out duration-500"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in-out duration-500"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="absolute inset-0 bg-red-900 bg-opacity-75 transition-opacity" />
            </Transition.Child>
            <div className="fixed inset-y-0 right-0 pl-10 max-w-full flex">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <div className="relative w-screen max-w-md">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 left-0 -ml-8 pt-4 pr-2 flex sm:-ml-10 sm:pr-4">
                      <button
                        className="text-white focus:outline-none focus:ring-2 focus:ring-white bg-transparent hover:bg-transparent p-0"
                        onClick={() => setOpen(false)}
                      >
                        <span className="sr-only">Close panel</span>
                        <XIcon className="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="h-full flex flex-col py-6 bg-red-900 shadow-xl overflow-y-scroll">
                    <nav className="flex flex-col mt-4 px-4">
                      <div className="w-32">
                        <UpdateLogoVersion imgData={logo} />
                      </div>

                      {nav.show_home_menu
                        ?
                        <div className="mt-4">
                          <Link to="/">
                            <button className="w-full px-4 py-2 text-base uppercase font-medium text-left text-white bg-site-red focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                              Home
                            </button>
                          </Link>
                        </div>
                        :
                        null
                      }

                      <Disclosure as="div" className="mt-4">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="flex justify-between w-full px-4 py-2 text-base uppercase font-medium text-left text-white bg-site-black  hover:bg-black focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                              Products
                              <ChevronDownIcon
                                className={`${
                                  open ? 'transform rotate-180' : ''
                                } w-5 h-5 text-white`}
                              />
                            </Disclosure.Button>
                            <Disclosure.Panel className="flex flex-col items-start pl-8 pr-4 pt-4 pb-2 text-sm text-gray-500">
                              {products.map((product, index) => {
                                return (
                                  <Link
                                    to={product.link}
                                    key={index}
                                    className="text-base text-center font-medium text-white hover:text-gray-700 transition ease-in-out duration-150 mb-6"
                                  >
                                    {product.name}
                                  </Link>
                                )
                              })}
                            </Disclosure.Panel>
                          </>
                        )}
                      </Disclosure>

                      <Disclosure as="div" className="mt-4">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="flex justify-between w-full px-4 py-2 text-base uppercase font-medium text-left text-white bg-site-black  hover:bg-black focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                              Resources
                              <ChevronDownIcon
                                className={`${
                                  open ? 'transform rotate-180' : ''
                                } w-5 h-5 text-white`}
                              />
                            </Disclosure.Button>
                            <Disclosure.Panel className="flex flex-col items-start pl-8 pr-4 pt-4 pb-2 text-sm text-gray-500">
                              {resources.map((resource, index) => {
                                return (
                                  <Link
                                    to={resource.link}
                                    key={index}
                                    className="text-base text-center font-medium text-white hover:text-gray-700 transition ease-in-out duration-150 mb-6"
                                  >
                                    {resource.name}
                                  </Link>
                                )
                              })}
                            </Disclosure.Panel>
                          </>
                        )}
                      </Disclosure>

                      <div className="mt-4">
                        <Link to="/about">
                          <button className="w-full px-4 py-2 text-base uppercase font-medium text-left text-white bg-site-red focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                            {nav.about_menu_name}
                          </button>
                        </Link>
                      </div>                   

                      <div className="mt-4">
                        <Link to="/contact">
                          <button className="w-full px-4 py-2 text-base uppercase font-medium text-left text-white bg-site-red focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                            {nav.contact_menu_name}
                          </button>
                        </Link>
                      </div>
                    </nav>

                    <div className="mt-12 ml-8">
                      <a href={`tel:${nav.contact_image_phone_number}`}>
                        <ContactImageVersion imgData={contactImg} />
                      </a>
                    </div>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  )
}

export default MobileDrawerNew